module.exports = __webpack_public_path__ + "static/15-244645d9ab0cb2596214aefa6c2bc97a.jpg";